module.exports = __webpack_public_path__ + "static/media/home.e8b2b379.jpg";